const tableHeader = [
  {
    title: 'payment_file.upload_logs.header.status',
  },
  {
    title: 'payment_file.upload_logs.header.batch_name',
  },
  {
    title: 'payment_file.upload_logs.header.schedule',
  },
  {
    title: 'payment_file.upload_logs.header.total_amount',
  },
  {
    title: 'payment_file.upload_logs.header.total_count',
  },
  {
    title: 'payment_file.upload_logs.header.upload_by',
  },
  {
    title: '',
  },
  {
    title: 'payment_file.upload_logs.header.update_by',
  },
  {
    title: 'payment_file.upload_logs.header.update_date',
  },
  {
    title: '',
    action: true,
  },
];

export default tableHeader;
